<div mat-dialog-content class="loading-content">
    <mat-spinner diameter="48"></mat-spinner>
    <p class="loading-message">{{ data.message || 'Loading...' }}</p>
</div>